import { createFileRoute } from '@tanstack/react-router';

/** ?chunk=N — the citation anchor the reader scrolls to (R4/§9.3). */
interface ReaderSearch {
  chunk?: number;
}

export const Route = createFileRoute('/_authenticated/brain/library/$sourceId')({
  validateSearch: (search: Record<string, unknown>): ReaderSearch => {
    const n = Number(search.chunk);
    return Number.isFinite(n) && n >= 0 ? { chunk: n } : {};
  },
}).lazy(() => import('./library.$sourceId.lazy').then((d) => d.Route));
